<template>
  <div class="header-menu tw-h-16">
    <div class="top-menu">
      <div
        class="tw-w-full tw-hidden tw-h-16 tw-bg-white md:tw-flex tw-shadow-sm xl:tw-px-28 lg:tw-px-10 md:tw-px-10"
      >
        <div class="tw-h-16 tw-flex tw-flex-none tw-items-center">
          <a href="/" @click="clearRedirectUrl">
            <img class="tw-h-10" src="@/static/staimg/tiansheng.png" alt />
          </a>
        </div>
        <div
          class="tw-flex tw-items-center tw-flex-1 tw-h-16 tw-justify-end xl:tw-gap-4 tw-gap-3"
        >
          <div class="tw-flex tw-items-center tw-cursor-pointer tw-flex-none">
            <span
              class="tw-text-sm tw-text-textMain tw-font-medium tw-mr-10 hover:tw-text-primary"
              @click="handleClickRoute('/activity')"
              >{{ $t("往届活动") }}</span
            >
            <template v-if="userInfo && userInfo.id !== null">
              <UserInfo @outLogin="handleLoginOut"></UserInfo>
            </template>

            <template v-else>
              <b-link
                class="user-login"
                @click="handleClickRoute('/login')"
                type="primary"
                size="sm"
              >
                {{ $t("登录") }}
              </b-link>
              <b-button
                class="user-register"
                pill
                variant="primary"
                @click="handleClickRoute('/register')"
                size="sm"
              >
                {{ $t("注册") }}
              </b-button>
            </template>
          </div>
        </div>
      </div>
      <!-- 移动端头部  -->
      <div
        class="mobile tw-flex md:tw-hidden tw-h-16 tw-bg-white tw-items-center tw-justify-between tw-px-4"
      >
        <a href="/">
          <img class="tw-h-10" src="@/static/staimg/tiansheng.png" alt />
        </a>
        <div class="tw-flex tw-items-center tw-cursor-pointer tw-flex-none">
          <span
            class="tw-text-sm tw-text-textMain tw-font-medium tw-mr-5 hover:tw-text-primary"
            @click="handleClickRoute('/activity')"
            >{{ $t("往届活动") }}</span
          >
          <template v-if="userInfo && userInfo.id !== null">
            <UserInfo @outLogin="handleLoginOut"></UserInfo>
          </template>
          <template v-else>
            <b-link
              class="user-login"
              @click="handleClickRoute('/login')"
              type="primary"
              size="sm"
            >
              {{ $t("登录") }}
            </b-link>
            <b-button
              class="user-register"
              pill
              variant="primary"
              @click="handleClickRoute('/register')"
              size="sm"
            >
              {{ $t("注册") }}
            </b-button>
          </template>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState } from "vuex";
import BaseLayout from "../BaseLayout.vue";
import UserInfo from "./UserInfo.vue";
import { indexApi, logoutApi, contactInfoApi } from "@/api/modules/home";
export default {
  components: {
    BaseLayout,
    UserInfo,
  },
  data() {
    return {
      // 默认语言
      sleLang: "zh-CN",
      userInfo: "",
    };
  },
  watch: {
    openSearch(newVal) {
      if (newVal) {
        document.body.style.overflow = "hidden";
        document.documentElement.style.overflow = "hidden";
      } else {
        document.body.style.overflow = "";
        document.documentElement.style.overflow = "";
      }
    },
  },
  computed: {
    isLang() {
      return this.$store.state.isLang !== "zh-CN" ? "en" : "zh-CN";
    },
    isLan() {
      return this.$store.state.isCla;
    },
    // 当前路由名称
    routName() {
      return this.$route.name;
    },
  },
  beforeDestroy() {},
  async created() {
    this.getLang();
    this.getContactInfo();
    await this.getIndex();
    this.userInfo = localStorage.getItem("userInfo");
    this.userInfo = JSON.parse(this.userInfo);
  },
  mounted() {},
  methods: {
    getIndex() {
      indexApi().then((res) => {
        this.$store.commit("SET_INDEXINFO", res.data);
        localStorage.setItem(
          "indexInfo",
          JSON.stringify(this.$store.state.indexInfo)
        );
      });
    },
    getContactInfo() {
      contactInfoApi().then((res) => {
        this.$store.commit("SET_CONTACTINFO", res.data);
        localStorage.setItem(
          "indexInfo",
          JSON.stringify(this.$store.state.indexInfo)
        );
      });
    },
    clearRedirectUrl() {
      localStorage.removeItem("redirectUrl");
    },
    // 获取语言
    getLang() {
      this.sleLang = this.$store.state.isLang;
    },
    // 切换语言
    getSel(lang) {
      this.sleLang = lang;
      this.$store.commit("SET_LANG", lang);
      this.$i18n.locale = lang;
      location.reload();
    },

    // 页面跳转
    handleClickRoute(routeName) {
      localStorage.setItem("redirectUrl", this.$route.fullPath);
      if (
        this.$route.path === routeName ||
        typeof routeName !== "string" ||
        !routeName.includes("/")
      )
        return;
      this.showKey = 0;
      this.$router.push(routeName);
    },
    // 退出
    async handleLoginOut() {
      try {
        await logoutApi();
      } catch (error) {
        console.warn("退出登录接口调用失败，已清理本地登录状态", error);
      } finally {
        localStorage.removeItem("userInfo");
        localStorage.removeItem("token");
        this.$store.commit("SET_LOGIN", false);
        this.$store.commit("SET_VERIFICATION", "0");
        this.$router.go(0);
        window.location.reload();
      }
    },
  },
};
</script>
<style scoped lang="scss">
// 固定在顶部
.top-menu {
  position: fixed;
  top: 0;
  width: 100%;
  display: flex;
  flex-direction: column;
  z-index: 100;
  box-shadow: 0px 4px 20px 0px rgba(0, 0, 0, 0.03);
}

.user-login {
  line-height: 38px;
  padding: 0 15px;
  color: #444;
  text-decoration: none;
  font-size: 14px;

  &:hover {
    cursor: pointer;
    // background: #2878ff;
    color: #000;
  }
}
.user-register {
  padding: 4px 15px;
  text-decoration: none;
  font-size: 14px;
}
</style>
